import React from 'react';
import { Link } from 'react-router-dom';
import GeoPhone from './GeoData';
import { useModal } from "../contexts/ModalContext";

export default function Footer({ footerHide }) {
    const { openQueryModal } = useModal();
  return (
    <>
      <footer className={`footer-section ${footerHide || ""}`}>
        <div className="footer-top">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 col-lg-7">
                <div className="footer-content">

                  <div className="footer-logo">
                    <img src="/assets/images/trusted-image-footer.webp" alt="Logo" className="img-responsive" />
                  </div>

                  <div className="heading">Quick. Fast. Reliable.</div>
                  <div className="desktop-des"> <p>Experience our solutions and services first-hand, and we are confident that you will place your trust in us. </p>
                  </div>
                  <div className="mobile-des"> <p>Experience you can rely on.</p>
                  </div>

                  <div className="call-text">
                    {/* <Link to="tel:+91-124-4807600" >Call Us at : <span></span></Link> */}
                    Call Us at : <GeoPhone variant="footer" />
                  </div>
                  <div className="call-btn">
                    <Link to="/contact" className="default-btn"><span >Get Started </span></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="footer-links">
              <ul className="footer-items">
                <li><Link to="/about">About</Link></li>
                <li><Link to="/heathcare-medical-grade-commercial-laundry" >Industries </Link></li>
                <li><Link to="/product-listing">Products</Link></li>
                <li><Link to="/blog" >Blogs</Link></li>
                <li><Link to="/careers" >Careers</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <div className="container">
            <div className="row copyright-row">
              <div className="col-sm-9 col-md-8 col-lg-6">
                <div className="copyright-text">
                  <p>© 2026  Supershine  Designed by <Link rel="noopener noreferrer" to="https://www.88gravity.com" target="_blank">88gravity</Link> 
                   </p>
                </div>
              </div>
              <div className="col-sm-3 col-md-4 col-lg-6">
                <div className="copyright-link">
                  <ul>
                    {/* <li><Link><i className="fa-brands fa-instagram"></i></Link></li>
                    <li>
                      <a href="https://www.facebook.com/share/1A6nhWDeu9/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f"></i></a>
                    </li> */}
                    <li>
                      <a href="https://www.linkedin.com/company/supershine-laundry-official/" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="book-button">
        <Link onClick={openQueryModal}><span>Let's Connect!</span></Link>
      </div>
    </>
  )
}
